<template>
  <div class="container">
    <img
      v-for="i in 18"
      ref="waves"
      :key="i"
      :class="`waves${i}`"
      :src="$image('normal/illusts/waves.svg')"
      alt=""
    />
  </div>
</template>

<script>
import gsap from 'gsap';

export default {
  mounted() {
    this.animate();
  },
  methods: {
    animate() {
      gsap.fromTo(this.$refs.waves, {
        x: "10%",
      },{
        x: "-10%",
        duration: 2,
        repeat: -1,
        ease: 'power1.inOut',
        yoyo: true,
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  position: absolute;
  top: 0;
  left: 0;
  width: var(--app-width);
  height: var(--app-height);

  pointer-events: none;

  z-index: var(--z-index-bg-waves);

  [class*="waves"] {
    position: absolute;
    top: 0;
    left: 0;
    width: calc(var(--size-base) * 71.64);
  }

  .waves {
    &1 {
      top: 20%;
      left: 8%;
    }
    &2 {
      top: 4%;
      left: 53%;
    }
    &3 {
      top: 9%;
      left: 72%;
    }
    &4 {
      top: 11.6%;
      left: 93.6%;
    }
    &5 {
      top: 32.9%;
      left: 19.9%;
    }
    &6 {
      top: 33.9%;
      left: 31.9%;
    }
    &7 {
      top: 29.9%;
      left: 47.6%;
    }
    &8 {
      top: 34.6%;
      left: 61.3%;
    }
    &9 {
      top: 31.2%;
      left: 69%;
    }
    &10 {
      top: 63.9%;
      left: 1.6%;
    }
    &11 {
      top: 50.9%;
      left: 13.6%;
    }
    &12 {
      top: 63.9%;
      left: 41.6%;
    }
    &13 {
      top: 57.9%;
      left: 54.6%;
    }
    &14 {
      top: 69.9%;
      left: 69.6%;
    }
    &15 {
      top: 61.9%;
      left: 85.6%;
    }
    &16 {
      top: 85.9%;
      left: 19.6%;
    }
    &17 {
      top: 89.9%;
      left: 34.6%;
    }
    &18 {
      top: 49.9%;
      left: 90.6%;
    }
  }
}
</style>